import { useEffect } from "react";

export default function JoinPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) localStorage.setItem("pendingInviteToken", token);
    const t = setTimeout(() => { window.location.replace("/"); }, 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{
      minHeight: "100dvh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      background: "#f5f6fa", fontFamily: "'Noto Sans KR', sans-serif",
    }}>
      <style>{`@keyframes joinSpin { to { transform: rotate(360deg); } }`}</style>
      <div style={{
        width: 44, height: 44, borderRadius: "50%",
        border: "4px solid #f0f0f0", borderTop: "4px solid #E8412A",
        animation: "joinSpin 0.8s linear infinite", marginBottom: 24,
      }} />
      <p style={{ fontSize: 17, fontWeight: 700, color: "#1A1A2E", margin: "0 0 8px", textAlign: "center" }}>
        팀 초대 링크를 확인했어요!
      </p>
      <p style={{ fontSize: 13, color: "#9ca3af", margin: 0, textAlign: "center", lineHeight: 1.6 }}>
        로그인 후 자동으로 팀에 가입됩니다.
      </p>
    </div>
  );
}
